
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import SourceIQLogo from "../UILibrary/SourceIQLogo";

const Header = ({ navigateToEarlyAccess, buttonBgColor, buttonTextColor, logoFillColor, buttonText}) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <div
      className={`flex justify-center md:justify-between items-center p-6 fixed top-0 z-[1000] w-full md:pl-36 md:pr-14 transition-all duration-300 ${
        isScrolled ? "bg-white shadow-md" : "bg-transparent"
      }`}
    >
      <div
        className="w-full flex justify-center md:justify-start cursor-pointer"
        onClick={() => navigate("/")}
      >
        <SourceIQLogo fill={logoFillColor} width={150} height={30} />
      </div>
      <button
        onClick={navigateToEarlyAccess}
        className={`hidden md:flex h-14 px-5 rounded-[13px] justify-center items-center gap-2`}
        style={{
          backgroundColor: buttonBgColor,
        }}
      >
        <span
          className={`text-center text-base font-medium whitespace-nowrap`}
          style={{
            color: buttonTextColor,
          }}
        >
          {buttonText}
        </span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="12"
          height="14"
          viewBox="0 0 12 14"
          fillRule="none"
        >
          <path
            d="M12 7L0 14L6.05683e-07 0L12 7Z"
            fill={buttonTextColor}
          />
        </svg>
      </button>
    </div>
  );
};

export default Header;
